module.exports = __webpack_public_path__ + "static/media/BG_33.30da2ff6.png";